import { put, takeEvery, takeLatest, call } from '@redux-saga/core/effects';
import {
  get_meal,
  get_meal_error,
  get_meal_success,
  add_recipe_product_success,
  add_recipe_product_error,
  add_recipe_product,
} from './reducer';
import api from '@service/DataService';
import toast from 'react-hot-toast';

function* getMealSagas({ payload }) {
  try {
    const requestRes = yield call(api.get, `/products/${payload}`);
    const responseData = requestRes.data;
    const response = responseData.data;
    const base_ingredients = response.base_ingredients.map((ingredient) => {
      let temp = {
        ...ingredient,
        selected: true,
      };
      return temp;
    });

    let data = {
      ...response,
      base_ingredients,
    };
    yield put({
      type: get_meal_success.type,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: get_meal_error.type,
    });
  }
}

function* addRecipeProductSaga({ payload }) {
  try {
    const { id } = payload;
    delete payload.id;
    const requestRes = yield call(
      api.post,
      `/group_basket/${id}/add_recipe_product`,
      payload,
    );
    const responseData = requestRes.data;
    const response = responseData.message;
    toast.success(response);
    yield put({
      type: add_recipe_product_success.type,
    });
  } catch (error) {
    yield put({
      type: add_recipe_product_error.type,
    });
  }
}

function* mealSagas() {
  yield takeEvery(get_meal.type, getMealSagas);
  yield takeLatest(add_recipe_product.type, addRecipeProductSaga);
}

export default mealSagas;
